export const arraysShallowEqual = (a, b) => {
    return (Array.isArray(a) &&
        Array.isArray(b) &&
        a.length === b.length &&
        a.every((v, index) => v === b[index]));
};
//# sourceMappingURL=equality.js.map